<template>
    <div class="sirket-form">
        <el-form
                v-loading="loading"
                ref="sirketForm"
                :model="form"
                :rules="rules"
                label-position="left"
                label-width="125px">
            <el-form-item prop="adi" label="Şirket Adı">
                <el-input v-model="form.adi" maxlength="255" minlength="1" type="text"></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item prop="adres" label="Şirket Adresi">
                <el-input v-model="form.adres" maxlength="255" minlength="1" type="text"></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item prop="sirket_yetkili" label="Şirket Yetkili Adi">
                <el-input v-model="form.sirket_yetkili" maxlength="255" minlength="1" type="text"></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item prop="tel" label="Şirket Tel">
                <el-input v-model="form.tel" maxlength="15" minlength="1" type="text"></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item prop="cep" label="Şirket Cep Tel">
                <el-input v-model="form.cep" maxlength="15" minlength="1" type="text"></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item prop="sehir" label="Şehir">
                <el-input v-if="false" v-model="form.sehir" maxlength="45" minlength="1" type="text"></el-input>
                <el-select v-model="form.sehir" placeholder="Şehir seçiniz" class="sehir-select">
                    <el-option
                            v-for="s in sehirler"
                            :key="s.il"
                            :label="s.il"
                            :value="s.il"></el-option>
                </el-select>
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item prop="ilce" label="ilçe">
                <el-input v-if="false" v-model="form.ilce" maxlength="45" minlength="1" type="text"></el-input>
                <el-select v-model="form.ilce" placeholder="ilçe seçiniz" class="ilce-select">
                    <el-option
                            v-for="ilce in ilceleri"
                            :key="ilce"
                            :label="ilce"
                            :value="ilce"></el-option>
                </el-select>
            </el-form-item>

            <el-divider></el-divider>

            <el-row type="flex" justify="space-between">
                <el-form-item prop="posta_kodu" label="Posta Kodu">
                    <el-input v-model="form.posta_kodu" maxlength="45" minlength="1" type="text"></el-input>
                </el-form-item>
            </el-row>

            <el-divider></el-divider>


            <el-row class="mak-konum">
                <el-form-item prop="latitude" label="Konum">
                    <div v-if="false">Latitude: {{form.latitude}}</div>
                    <div v-if="false">Longitude: {{form.longitude}}</div>
                    <div v-if="form.latitude && form.longitude">
                        <mak-map
                                v-if="showViewMap"
                                view-only
                                :lat="form.latitude"
                                :lng="form.longitude"
                                @update="visibleMap = true"/>
                    </div>
                    <el-card v-else class="add-location" @click.native="visibleMap = true">
                        <el-button type="text">
                            <i class="el-icon-add-location"/>
                            Konum ekle</el-button>
                    </el-card>
                </el-form-item>
            </el-row>

            <el-divider></el-divider>
        </el-form>
        <el-row type="flex" justify="center">
            <el-button type="primary" size="large" @click="submit">Kaydet</el-button>
        </el-row>

        <el-dialog :visible.sync="visibleMap" append-to-body fullscreen>
            <mak-map @close="visibleMap = false" @use="locationUse"/>
        </el-dialog>
    </div>
</template>

<script>
    import MakMap from '@/components/MakMap.vue'
    import ilceler from '@/common/ilceler.js'

    export default {
        name: 'sirket-form',
        components: {
            MakMap,
        },
        props: {
            visible: {type: Boolean},
            sirket: {type: Object, default: null},
        },
        data() {
            return {
                showViewMap: true,
                loading: false,
                visibleMap: false,
                form: {
                    adi: null,
                    adres: null,
                    sirket_yetkili: null,
                    tel: null,
                    cep: null,
                    sehir: 'Sakarya',
                    ilce: 'Adapazarı',
                    posta_kodu: '54100',
                    konum: null,
                    latitude: null,
                    longitude: null,
                },
                rules: {
                    adi: [{required: true, message: 'Adi gerekli', trigger: 'change'}],
                    adres: [{required: true, message: 'Fatura Bilgisi gerekli', trigger: 'change'}],
                    sirket_yetkili: [{required: true, message: 'Şirket yetkili gerekli', trigger: 'change'}],
                    // tel: [{required: true, message: 'Şirket tel gerekli', trigger: 'change'}],
                    cep: [{required: true, message: 'Şirket Cep tel gerekli', trigger: 'change'}],
                    sehir: [{required: true, message: 'Şehir gerekli', trigger: 'change'}],
                    ilce: [{required: true, message: 'ilçe gerekli', trigger: 'change'}],
                    // posta_kodu: [{required: true, message: 'Posta kodu gerekli', trigger: 'change'}],
                }
            };
        },
        computed: {
            link() {
                const { latitude, longitude } = this.form;
                if (!latitude || !longitude) {
                    return;
                }
                return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
            },
            sehirler() {
                return ilceler.filter(sehir => [41, 54, 81].includes(sehir.plaka));
            },

            ilceleri() {
                if (!this.form.sehir) {
                    return [];
                }
                const sehir = ilceler.find(sehir => sehir.il === this.form.sehir);
                return sehir && sehir.ilceleri || [];
            },
        },
        methods: {
            locationUse(position) {
                // console.warn(position, position.lat(), position.lng());

                if (position) {
                    this.form.latitude = position.lat();
                    this.form.longitude = position.lng();
                    this.visibleMap = false;

                    this.showViewMap = false;
                    setTimeout(() => {
                        this.showViewMap = true;
                    }, 500)
                }
            },
            submit() {
                this.$refs.sirketForm.validate((valid) => {
                    if (valid) {
                        if (!this.sirket) {
                            this.create();
                        } else {
                            this.update();
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            create() {
                this.loading = true;
                this.$requests.Sirket.createSirket(this.form)
                    .then(() => {
                        this.$refs.sirketForm.resetFields();
                        this.$emit('success');
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            update() {
                let sirket = Object.assign({}, this.form);
                delete sirket.id;
                this.loading = true;
                this.$requests.Sirket.updateSirket(this.form.id, sirket)
                    .then(() => {
                        this.$refs.sirketForm.resetFields();
                        this.$emit('success');
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            if (this.visible && this.sirket) {
                this.form = Object.assign({}, this.sirket);
            }
        },
        watch: {
            visible() {
                if (this.visible && this.sirket) {
                    this.form = Object.assign({}, this.sirket);
                }
            },
            ilceleri() {
                if (this.ilceleri.length) {
                    this.form.ilce = this.ilceleri[0];
                } else {
                    this.form.ilce = null;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .mak-konum {

        .add-location {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }
    .sehir-select {
        width: 100%;
    }
    .ilce-select {
        width: 100%;
    }
    .el-divider {
        margin: 0 0 25px 0;
        visibility: hidden;
    }
</style>
